module.exports = __webpack_public_path__ + "static/assets/d802f50f3620d7517ae0691e67f20cad.svg";